export enum S1PythonCommand {
	STOP, UNINSTALL, DELETE, INSTALL, START, AUTOSTART_ON, AUTOSTART_OFF, PING, GET
}
